/**
 * @generated SignedSource<<c0d801a22b2443fa1e39462f39e62d13>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PatientAppointmentForm_query$data = {
  readonly clinicians: {
    readonly nodes: ReadonlyArray<{
      readonly rowId: any;
      readonly user: {
        readonly firstName: string;
        readonly lastName: string;
      } | null;
    }>;
  } | null;
  readonly services: {
    readonly nodes: ReadonlyArray<{
      readonly duration: {
        readonly minutes: number | null;
      };
      readonly name: string;
      readonly rowId: any;
    }>;
  } | null;
  readonly " $fragmentType": "PatientAppointmentForm_query";
};
export type PatientAppointmentForm_query$key = {
  readonly " $data"?: PatientAppointmentForm_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"PatientAppointmentForm_query">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PatientAppointmentForm_query",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "orderBy",
          "value": [
            "USER_BY_USER_ID__FIRST_NAME_ASC",
            "USER_BY_USER_ID__LAST_NAME_ASC"
          ]
        }
      ],
      "concreteType": "CliniciansConnection",
      "kind": "LinkedField",
      "name": "clinicians",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Clinician",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "User",
              "kind": "LinkedField",
              "name": "user",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "firstName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "lastName",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "clinicians(orderBy:[\"USER_BY_USER_ID__FIRST_NAME_ASC\",\"USER_BY_USER_ID__LAST_NAME_ASC\"])"
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "condition",
          "value": {
            "isActive": true
          }
        }
      ],
      "concreteType": "ServicesConnection",
      "kind": "LinkedField",
      "name": "services",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Service",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Interval",
              "kind": "LinkedField",
              "name": "duration",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "minutes",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "services(condition:{\"isActive\":true})"
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "477a775359f56482d20f0b340d11060e";

export default node;
